import { ModelValue } from '../../AttributeValue';
import { AttributeValueInstance } from './AttributeValueInstance';

export class ModelValueInstance extends AttributeValueInstance<ModelValue> {
  constructor(attributeValue: ModelValue) {
    super(attributeValue);
  }
}
